import { useTheme, useMediaQuery } from '@mui/material';
import NotificheListPageDesktop from './NotificheListPageDesktop';
import NotificheListPageMobile from './NotificheListPageMobile';

export default function DocumentiListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <NotificheListPageMobile />
    : <NotificheListPageDesktop />;
}